export default __webpack_public_path__ + "static/media/HalfPage.02428c5b.png";